/* ============================================================================
   HDZS · bundle builder + "Find my setup" quiz runtime (sets agent). Vanilla ES5, no libraries.
   Depends on window.HDZB (hdzb.js) and window.HDZS (hdzs.js, the bundle engine) — both loaded `defer` before this file.
   Builder: sections/hdzs-builder.liquid + snippets/hdzs-pcard.liquid ([data-hdzs-builder]).
   Quiz:    sections/hdzs-quiz.liquid ([data-hdzs-quiz]).
   Money: raw cents in the active currency from Liquid JSON → HDZB.money; USD thresholds via HDZB.usd. Never parses price text.
   A set is added with ONE /cart/add.js call (HDZS.addSet) → the engine applies the tier code → UpCart opens.
   Wave 4: the quiz result's "Customize it" link opens the free-form builder (sections/hdzs-bundle.liquid, assets/hdzs-bundle.js)
   pre-filled via ?bundle=<variantId>[x<qty>],…  The old step builder below (Card/Builder) only runs if sections/hdzs-builder.liquid
   is on a page (it no longer is).
   ========================================================================== */
(function () {
  'use strict';
  function H() { return window.HDZB; }
  function E() { return window.HDZS; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(c) { return H() ? H().money(c) : '$' + (c / 100).toFixed(2); }
  function moneyT(c) { return H() ? H().money(c, { trim: true }) : '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(t, v) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return v[k] != null ? v[k] : m; }); }
  function on(el, ev, fn) { el.addEventListener(ev, fn, false); }
  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] == null || attrs[k] === false) return; if (k === 'class') el.className = attrs[k]; else if (k === 'html') el.innerHTML = attrs[k]; else if (k === 'text') el.textContent = attrs[k]; else el.setAttribute(k, attrs[k] === true ? '' : attrs[k]); });
    (children || []).forEach(function (c) { if (c == null) return; el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  var ICONS = {
    check: '<path d="M20 6 9 17l-5-5"/>', x: '<path d="M18 6 6 18M6 6l12 12"/>', truck: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    'circle-check': '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>', plus: '<path d="M5 12h14"/><path d="M12 5v14"/>', repeat: '<path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/>', 'arrow-right': '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>', 'arrow-left': '<path d="m12 19-7-7 7-7"/><path d="M19 12H5"/>'
  };
  var TPL = null;
  function svgFromTpl(name, size) {
    if (TPL === null) { var t = document.querySelector('template[data-hdzs-icons]'); TPL = t ? t.content : false; }
    if (!TPL) return '';
    var n = TPL.querySelector('[data-i="' + name + '"] svg'); if (!n) return '';
    var c = n.cloneNode(true); if (size) { c.setAttribute('width', size); c.setAttribute('height', size); c.style.width = size + 'px'; c.style.height = size + 'px'; }
    return c.outerHTML;
  }
  function icon(name, size, stroke) { var t = svgFromTpl(name, size); if (t) return t; return '<svg class="hdzb-i" viewBox="0 0 24 24" width="' + (size || 18) + '" height="' + (size || 18) + '" fill="none" stroke="currentColor" stroke-width="' + (stroke || 2.5) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>'; }
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function headerH() { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hdzb-header-h')); return isNaN(v) ? 72 : v; }
  function scrollToEl(el, pad) { if (!el) return; var y = el.getBoundingClientRect().top + window.scrollY - headerH() - (pad == null ? 12 : pad); window.scrollTo({ top: Math.max(0, y), behavior: RM ? 'auto' : 'smooth' }); }
  function bump(el) { if (!el || RM) return; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
  function setText(el, txt) { if (!el) return; if (el.textContent !== txt) { el.textContent = txt; bump(el); } }
  function list(s) { return String(s || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean); }
  function variantOk(p, v) {
    var t = String(v.title).toLowerCase(), inc = list(p.include), exc = list(p.exclude);
    if (inc.length && !inc.some(function (x) { return t.indexOf(x) > -1; })) return false;
    if (exc.some(function (x) { return t.indexOf(x) > -1; })) return false;
    return true;
  }
  function pool(p) { return (p.variants || []).filter(function (v) { return variantOk(p, v); }); }
  function optIndex(p, sub) { for (var i = 0; i < (p.options || []).length; i++) if (String(p.options[i]).toLowerCase().indexOf(sub) > -1) return i; return -1; }
  function findVariant(p, chosen) {
    var vs = pool(p);
    var exact = vs.filter(function (v) { return chosen.every(function (val, i) { return val == null || v.opts[i] === val; }); });
    return exact.filter(function (v) { return v.available; })[0] || exact[0] || null;
  }
  function byId(p, id) { return (p.variants || []).filter(function (v) { return Number(v.id) === Number(id); })[0] || null; }
  function isDefaultTitle(v) { return !v || v.title === 'Default Title'; }

  /* ---------- Pick: one product in a set (pair = two units with a hand each) ---------- */
  function Pick(p, o) {
    o = o || {};
    this.p = p; this.qty = Math.max(1, Number(o.qty) || 1); this.on = o.on !== false;
    this.role = o.role || p.key || 'extras'; this.why = o.why || ''; this.optional = !!o.optional;
    var v = (o.variantId && byId(p, o.variantId)) || byId(p, p.defaultVariant) || pool(p).filter(function (x) { return x.available; })[0] || p.variants[0];
    this.chosen = v ? v.opts.slice() : (p.options || []).map(function () { return null; });
    this.chosen2 = this.chosen.slice();
    this.handIdx = optIndex(p, 'hand');
    /* products whose first variant is "Left Hand" (King Cast) opened the builder on a left-hand reel; 79% of units are
       right-hand → start on the right hand unless a caller asked for a specific variant (quiz sets the hand itself) */
    if (!o.variantId && this.handIdx > -1 && this.hand(0) === 'left') {
      var rc = this.chosen.slice(), rv = this.values(this.handIdx).filter(function (x) { return String(x).toLowerCase().indexOf('right') > -1; })[0];
      if (rv) { rc[this.handIdx] = rv; var rvv = findVariant(p, rc); if (rvv && rvv.available) { this.chosen = rc; this.chosen2 = rc.slice(); } }
    }
  }
  Pick.prototype.variant = function (which) { return findVariant(this.p, which === 1 ? this.chosen2 : this.chosen); };
  Pick.prototype.set = function (i, val, which) {
    var ch = which === 1 ? this.chosen2 : this.chosen;
    ch[i] = val;
    if (!findVariant(this.p, ch)) {                                   /* combination does not exist → snap the other options to a variant that has this value */
      var alt = pool(this.p).filter(function (v) { return v.opts[i] === val && v.available; })[0] || pool(this.p).filter(function (v) { return v.opts[i] === val; })[0];
      if (alt) alt.opts.forEach(function (x, j) { ch[j] = x; });
    }
  };
  Pick.prototype.setHand = function (side, which) {                  /* side: 'right' | 'left' */
    if (this.handIdx < 0) return;
    var vals = this.values(this.handIdx), pick = vals.filter(function (v) { return v.toLowerCase().indexOf(side) > -1; })[0];
    if (pick) this.set(this.handIdx, pick, which);
  };
  Pick.prototype.hand = function (which) { var v = this.variant(which); if (!v || this.handIdx < 0) return ''; return String(v.opts[this.handIdx] || '').toLowerCase().indexOf('left') > -1 ? 'left' : 'right'; };
  Pick.prototype.values = function (i) { var seen = {}, out = []; pool(this.p).forEach(function (v) { var x = v.opts[i]; if (x != null && !seen[x]) { seen[x] = 1; out.push(x); } }); return out; };
  Pick.prototype.units = function () { return this.p.pair ? 2 : this.qty; };
  Pick.prototype.price = function () { var v = this.variant(0); return v ? Number(v.price) : 0; };
  Pick.prototype.compare = function () { var v = this.variant(0); return v ? Number(v.compare) || 0 : 0; };
  Pick.prototype.total = function () { if (this.p.pair) { var a = this.variant(0), b = this.variant(1); return (a ? Number(a.price) : 0) + (b ? Number(b.price) : 0); } return this.price() * this.qty; };
  Pick.prototype.bogo = function () { if (!this.p.pair) return 0; var b = this.variant(1); return b ? Number(b.price) : 0; };   /* the second unit is free (native automatic discount) */
  Pick.prototype.available = function () { var a = this.variant(0); if (!a || !a.available) return false; if (this.p.pair) { var b = this.variant(1); return !!(b && b.available); } return true; };
  Pick.prototype.cartItems = function () {
    if (this.p.pair) { var a = this.variant(0), b = this.variant(1); if (!a || !b) return []; return a.id === b.id ? [{ id: a.id, quantity: 2 }] : [{ id: a.id, quantity: 1 }, { id: b.id, quantity: 1 }]; }
    var v = this.variant(0); return v ? [{ id: v.id, quantity: this.qty }] : [];
  };
  Pick.prototype.engineLines = function () {
    var p = this.p, self = this;
    return this.cartItems().map(function (it) { var v = byId(p, it.id); return { handle: p.handle, product_id: p.id, product_type: p.type, quantity: it.quantity, price: v ? Number(v.price) : 0, tags: p.tags || [], deal: !!p.deal }; });
  };
  Pick.prototype.label = function () {
    var v = this.variant(0);
    if (this.p.pair) { var a = this.hand(0), b = this.hand(1); return a === b ? 'Both ' + a + ' hand' : 'One ' + a + ' hand + one ' + b + ' hand'; }
    var parts = [];
    if (!isDefaultTitle(v)) parts.push(/^\d+$/.test(String(v.title)) ? '#' + v.title : v.title);   /* numbered lure styles read '#3', not '3' */
    if (this.qty > 1) parts.push('× ' + this.qty);
    return parts.join(' · ');
  };

  /* ---------- option pickers (hand = segmented control, ≤5 values = pills, else select, qty stepper) ---------- */
  function segHand(pick, which, label) {
    var cur = pick.hand(which);
    var g = h('div', { class: 'hdzb-seg', role: 'radiogroup', 'data-hdzb-radios': true, 'data-hdzs-hand': String(which), 'aria-label': label || 'Handle' });
    ['right', 'left'].forEach(function (side) {
      var vals = pick.values(pick.handIdx), has = vals.some(function (v) { return v.toLowerCase().indexOf(side) > -1; });
      var b = h('button', { type: 'button', class: 'hdzb-seg__o' + (cur === side ? ' is-on' : ''), role: 'radio', 'aria-checked': cur === side ? 'true' : 'false', 'data-value': side, disabled: !has });
      b.textContent = side === 'right' ? 'Right hand' : 'Left hand';
      g.appendChild(b);
    });
    return g;
  }
  function renderPickers(box, pick, o) {
    o = o || {};
    box.innerHTML = '';
    var p = pick.p;
    if (pick.handIdx > -1) {
      if (p.pair) {
        [0, 1].forEach(function (which) {
          var w = h('div', { class: 'hdzs-opt' });
          w.appendChild(h('span', { class: 'hdzs-opt__l', text: (o.reelLabels && o.reelLabels[which]) || ('Reel ' + (which + 1) + ' · handle on the') }));
          w.appendChild(segHand(pick, which, 'Reel ' + (which + 1) + ' handle'));
          box.appendChild(w);
        });
        if (o.mixHint) box.appendChild(h('p', { class: 'hdzs-opt__hint', text: o.mixHint }));
      } else {
        var w1 = h('div', { class: 'hdzs-opt' });
        w1.appendChild(h('span', { class: 'hdzs-opt__l', text: o.handLabel || 'Handle on the' }));
        w1.appendChild(segHand(pick, 0, 'Handle'));
        box.appendChild(w1);
      }
    }
    (p.options || []).forEach(function (name, i) {
      if (i === pick.handIdx) return;
      var vals = pick.values(i);
      if (vals.length < 2) return;
      var w = h('div', { class: 'hdzs-opt' });
      w.appendChild(h('span', { class: 'hdzs-opt__l', text: name }));
      var cur = pick.chosen[i];
      if (vals.length <= 5) {
        var row = h('div', { class: 'hdzb-pill-row', role: 'radiogroup', 'data-hdzb-radios': true, 'data-hdzs-opt': String(i), 'aria-label': name });
        vals.forEach(function (val) { var b = h('button', { type: 'button', class: 'hdzb-pill hdzb-pill--soft' + (val === cur ? ' is-on' : ''), role: 'radio', 'aria-checked': val === cur ? 'true' : 'false', 'data-value': val, text: val }); row.appendChild(b); });
        w.appendChild(row);
      } else {
        var sel = h('select', { class: 'hdzb-select hdzb-select--soft', 'data-hdzs-opt': String(i), 'aria-label': name });
        vals.forEach(function (val) { var op = h('option', { value: val, text: val }); if (val === cur) op.selected = true; sel.appendChild(op); });
        w.appendChild(sel);
      }
      box.appendChild(w);
    });
    if (!p.pair && Number(p.qtyMax) > 1) {
      var q = h('div', { class: 'hdzs-opt hdzs-opt__qty' });
      q.appendChild(h('span', { class: 'hdzs-opt__l', style: 'margin:0', text: 'Quantity' }));
      var st = h('div', { class: 'hdzb-qty hdzb-qty--sm', 'data-hdzb-qty': true });
      st.appendChild(h('button', { type: 'button', class: 'hdzb-qty__b', 'data-dir': '-1', 'aria-label': 'Fewer', html: '<svg class="hdzb-i" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 12h14"/></svg>' }));
      var inp = h('input', { class: 'hdzb-qty__in', type: 'number', min: '1', max: String(p.qtyMax), value: String(pick.qty), 'aria-label': 'Quantity', 'data-hdzs-qty': true });
      st.appendChild(inp);
      st.appendChild(h('button', { type: 'button', class: 'hdzb-qty__b', 'data-dir': '1', 'aria-label': 'More', html: '<svg class="hdzb-i" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><path d="M5 12h14M12 5v14"/></svg>' }));
      q.appendChild(st);
      box.appendChild(q);
    }
    if (H()) H().init(box);
  }
  /* wire a picker box: calls cb() after any change */
  function bindPickers(box, pick, cb) {
    on(box, 'hdzb:change', function (e) {
      var g = e.detail && e.detail.group; if (!g) return;
      if (g.hasAttribute('data-hdzs-hand')) pick.setHand(e.detail.value, Number(g.getAttribute('data-hdzs-hand')));
      else if (g.hasAttribute('data-hdzs-opt')) pick.set(Number(g.getAttribute('data-hdzs-opt')), e.detail.value, 0);
      cb();
    });
    on(box, 'change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('select[data-hdzs-opt]')) { pick.set(Number(t.getAttribute('data-hdzs-opt')), t.value, 0); cb(); }
      else if (t.matches && t.matches('[data-hdzs-qty]')) { pick.qty = Math.max(1, Math.min(Number(pick.p.qtyMax) || 1, Number(t.value) || 1)); cb(); }
    });
  }

  /* ---------- summary of a set (projection; the real cart is judged by the engine after adding) ---------- */
  function summarize(picks) {
    var eng = E(), lines = [], items = 0, bogo = 0, units = 0, count = 0, unavailable = false;
    picks.forEach(function (pk) { if (!pk.on) return; if (!pk.available()) unavailable = true; lines = lines.concat(pk.engineLines()); items += pk.total(); bogo += pk.bogo(); units += pk.units(); count++; });
    var st = eng ? eng.evaluate(lines, { withCart: true }) : { enabled: false, tier: 0, amount: 0, blockedByBogo: false };
    /* a saving is projected only when the checkout will honor it (HDZS.canProject: confirmed this session, or Theme setting "codes are live") */
    var dead = !!(st.tier > 0 && eng && eng.codeState(st.tierCode) === 'dead');
    var can = !!(st.tier > 0 && !dead && eng && eng.canProject(st.tierCode));
    var unknown = st.tier > 0 && !dead && !can;
    var bundle = can ? st.amount : 0;
    var proj = {}; Object.keys(st).forEach(function (k) { proj[k] = st[k]; }); proj.applied = can; proj.pending = st.tier > 0 && !can;
    var msg = eng && st.enabled ? eng.message(proj) : '';
    var total = Math.max(0, items - bogo - bundle);
    var usd = H() && H().currency === 'USD';
    var threshold = eng ? eng.usd(eng.freeShipUsdCents) : 10000;
    return { lines: lines, items: items, bogo: bogo, bundle: bundle, bundleDead: dead, bundleUnknown: unknown, proj: proj, total: total, units: units, count: count, state: st, message: msg, unavailable: unavailable, usd: usd, shipThreshold: threshold, shipRemaining: Math.max(0, threshold - total) };
  }
  function paintRows(root, sum, cfg) {
    var q = function (s) { return $(s, root); };
    var rows = q('[data-hdzs-rows]'), empty = q('[data-hdzs-empty]');
    if (rows) rows.hidden = sum.count === 0;
    if (empty) empty.hidden = sum.count > 0;
    var sub = q('[data-hdzs-sub]'); if (sub) sub.textContent = money(sum.items);
    var rb = q('[data-hdzs-row-bogo]'); if (rb) { rb.hidden = sum.bogo <= 0; var b = q('[data-hdzs-bogo]'); if (b) b.textContent = 'Save ' + money(sum.bogo); }
    var rbu = q('[data-hdzs-row-bundle]');
    if (rbu) {
      var show = sum.state.enabled && sum.state.tier > 0 && !sum.state.blockedByBogo;
      rbu.hidden = !show;
      var l = q('[data-hdzs-bundle-l]'), v = q('[data-hdzs-bundle]');
      rbu.classList.toggle('is-neutral', sum.bundleDead || sum.bundleUnknown);
      if (l) l.textContent = sum.bundleDead ? (cfg.bundleDeadLabel || 'Bundle code') : (cfg.rowBundle || 'Bundle deal');
      if (v) v.textContent = sum.bundleDead ? (cfg.bundleDeadValue || 'not applied') : sum.bundleUnknown ? (cfg.rowBundleUnknown || 'checked in your cart') : 'Save ' + money(sum.bundle);
    }
    var t2 = q('[data-hdzs-total2]'); if (t2) setText(t2, money(sum.total));
    var tr = q('[data-hdzs-ptrack]');
    if (tr && E() && E().paintTrack) { var showTr = sum.count > 0 && sum.state.enabled && !sum.state.blockedByBogo && !sum.state.blockedByCode; if (showTr) E().paintTrack(tr, sum.proj, { applied: sum.bundle > 0 }); if (!showTr || (sum.state.tier > 0 && !(sum.bundle > 0))) tr.hidden = true; }
    var note = q('[data-hdzs-note]');
    if (note && !note.__busy) {
      var txt = '', kind = '';
      if (sum.count > 0 && sum.state.enabled) {
        if (sum.state.blockedByBogo) { txt = cfg.bogoNote || sum.message; }
        else if (sum.state.tier > 0 && sum.bundle > 0) { txt = (cfg.bundleNote || '') || sum.message; kind = 'is-ok'; }
        else if (sum.state.tier > 0 && sum.bundleUnknown) { txt = cfg.unknownNote || 'This set reaches the bundle deal. Your cart checks the code before you pay.'; }
        else if (sum.state.tier > 0 && sum.bundleDead) { txt = ''; }
        else if (sum.state.nextTier) { txt = sum.message; }
      }
      note.textContent = txt; note.hidden = !txt; note.className = note.className.replace(/\bis-(ok|err)\b/g, '').trim() + (kind ? ' ' + kind : '');
    }
    var ship = q('[data-hdzs-ship]');
    if (ship) {
      var showShip = sum.usd && sum.count > 0 && sum.shipThreshold > 0;
      ship.hidden = !showShip;
      if (showShip) {
        var done = sum.shipRemaining <= 0;
        ship.classList.toggle('is-done', done);
        var t = q('[data-hdzs-ship-t]'); if (t) t.textContent = done ? (cfg.shipDone || 'Ships free') : fill(cfg.shipMore || '{x} more for free shipping', { x: money(sum.shipRemaining) });
        var f = q('[data-hdzs-ship-fill]'); if (f) f.style.width = Math.min(100, Math.round(sum.total / sum.shipThreshold * 100)) + '%';
      }
    }
  }
  function dealLine(sum, cfg) {
    if (!sum.count || !sum.state.enabled) return { text: '', cls: '' };
    if (sum.bogo > 0 && sum.state.blockedByBogo) return { text: cfg.dealBogo || 'Second reel free', cls: '' };
    if (sum.state.tier > 0 && sum.bundle > 0) return { text: (cfg.dealBundle || 'Bundle deal: you save {amount}').replace('{amount}', moneyT(sum.bundle)), cls: '' };
    if (sum.state.tier > 0) return { text: cfg.dealUnknown || 'Bundle code checked in your cart', cls: 'is-neutral' };
    if (sum.state.nextTier) return { text: sum.message, cls: 'is-neutral' };
    return { text: '', cls: '' };
  }
  function addSetFlow(btn, picks, o) {
    o = o || {};
    var items = [];
    picks.forEach(function (pk) { if (pk.on) items = items.concat(pk.cartItems()); });
    if (!items.length || !E()) return Promise.resolve(false);
    var labels = { normal: btn.getAttribute('data-label') || btn.textContent, busy: btn.getAttribute('data-label-busy') || 'Adding…', done: btn.getAttribute('data-label-done') || 'Added — view cart' };
    btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); btn.innerHTML = '<span class="hdzs-spin" aria-hidden="true"></span><span>' + esc(labels.busy) + '</span>';
    return E().addSet(items, { attributes: o.attributes, open: o.open !== false, toast: false }).then(function () {
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.disabled = false; btn.innerHTML = icon('check', 22, 3) + '<span>' + esc(labels.done) + '</span>'; btn.setAttribute('data-added', '1');
      btn.classList.add('is-done'); bump(btn);
      if (o.onDone) o.onDone();
      return true;
    }).catch(function (e) {
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.disabled = false; btn.textContent = labels.normal;
      var msg = (e && e.data && e.message) || 'Could not add to cart. Please try again.';   /* Shopify's JSON reason only — never a parser error */
      if (e && (e.status === 429 || e.status === 503 || e.name === 'SyntaxError' || e.name === 'TypeError')) msg = 'The store is busy right now — please try again in a moment.';
      try { if (H() && H().toast) H().toast(msg, { kind: 'err' }); } catch (x) { }
      if (o.onError) o.onError(msg);
      return false;
    });
  }

  /* ======================================================================
     BUILDER
     ====================================================================== */
  function Card(el, builder) {
    var self = this;
    this.el = el; this.builder = builder;
    this.p = JSON.parse($('[data-hdzs-pdata]', el).textContent);
    this.step = el.getAttribute('data-step') || this.p.key;
    this.single = el.hasAttribute('data-single');
    this.pick = new Pick(this.p, { qty: 1 });
    this.pick.on = false;
    this.opts = $('[data-hdzs-opts]', el);
    this.btn = $('[data-hdzs-pick]', el);
    this.preOn = el.hasAttribute('data-on');
    on(this.btn, 'click', function () { self.setOn(!self.pick.on); });
    bindPickers(this.opts, this.pick, function () { self.refresh(); builder.update(); });
    this.refresh();
  }
  Card.prototype.setOn = function (v, silent) {
    var self = this;
    if (v && !this.pick.available()) return;
    if (v && this.single) this.builder.cards.forEach(function (c) { if (c !== self && c.step === self.step && c.pick.on) c.setOn(false, true); });
    this.pick.on = v;
    this.el.classList.toggle('is-on', v);
    this.btn.setAttribute('aria-pressed', v ? 'true' : 'false');
    if (v && !this.opts.__built) { this.opts.__built = true; renderPickers(this.opts, this.pick, { reelLabels: this.builder.cfg.reelLabels, mixHint: this.p.pair ? this.builder.cfg.mixHint : '' }); }
    this.opts.hidden = !v || !this.opts.children.length;
    this.el.classList.toggle('is-open', !this.opts.hidden);
    if (v && !silent) bump(this.el);
    var stepEl = this.el.closest('[data-hdzs-step]'); if (stepEl) stepEl.classList.remove('is-skipped');
    this.refresh();
    if (!silent) this.builder.update();
  };
  Card.prototype.refresh = function () {
    var v = this.pick.variant(0), now = $('[data-hdzs-now]', this.el), was = $('[data-hdzs-was]', this.el), sel = $('[data-hdzs-sel]', this.el);
    if (now && v) now.textContent = money(Number(v.price));
    if (was && v) { var c = Number(v.compare) || 0; was.hidden = !(c > Number(v.price)); if (c > Number(v.price)) was.textContent = money(c); }
    if (sel) sel.textContent = this.pick.on ? this.pick.label() : '';
    this.el.classList.toggle('is-off', !this.pick.available());
  };
  function Builder(root) {
    var self = this;
    this.root = root;
    try { this.cfg = JSON.parse($('[data-hdzs-tray-cfg]', root).textContent); } catch (e) { this.cfg = {}; }
    this.cards = $$('[data-hdzs-card]', root).filter(function (el) { return $('[data-hdzs-pdata]', el); }).map(function (el) { return new Card(el, self); });
    this.cards.forEach(function (c) { if (c.preOn) c.setOn(true, true); });   /* preselection after the list exists (single steps deselect siblings) */
    this.tray = $('[data-hdzs-tray]', root);
    this.addBtn = $('[data-hdzs-add-set]', root);
    this.note = $('[data-hdzs-note]', root);
    $$('[data-hdzs-skip]', root).forEach(function (b) {
      on(b, 'click', function () {
        var stepEl = b.closest('[data-hdzs-step]'), key = stepEl.getAttribute('data-hdzs-step');
        self.cards.forEach(function (c) { if (c.step === key && c.pick.on) c.setOn(false, true); });
        stepEl.classList.add('is-skipped');
        self.update();
        var next = stepEl.nextElementSibling; if (next && next.hasAttribute('data-hdzs-step')) scrollToEl(next);
      });
    });
    /* step flow: overview chips + "Next" links scroll to a step; the last one opens / scrolls to the tray */
    $$('[data-hdzs-goto]', root).forEach(function (a) {
      on(a, 'click', function (e) {
        var key = a.getAttribute('data-hdzs-goto');
        e.preventDefault();
        if (key === 'tray') { if (window.innerWidth < 990 && self.tray && !self.tray.classList.contains('is-open')) { var tg = $('[data-hdzs-tray-toggle]', root); if (tg) tg.click(); } else scrollToEl(self.tray); return; }
        var el = $('[data-hdzs-step="' + key + '"]', root); scrollToEl(el);
        var first = el && $('[data-hdzs-pick], .hdzs-card__pick', el); if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) { } }, RM ? 0 : 450);
      });
    });
    var tog = $('[data-hdzs-tray-toggle]', root);
    if (tog) on(tog, 'click', function () { if (window.innerWidth >= 990) return; var open = !self.tray.classList.contains('is-open'); self.tray.classList.toggle('is-open', open); tog.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (this.addBtn) on(this.addBtn, 'click', function () {
      if (self.addBtn.getAttribute('data-added') === '1') { H().cart.open(); return; }
      if (self.note) { self.note.__busy = true; }
      addSetFlow(self.addBtn, self.picks(), {
        attributes: { _hdzs_source: 'builder' },   /* 06.10: order attribute → Flow tag «Bundle Builder» */
        onDone: function () { if (self.note) { self.note.textContent = self.cfg.added || 'Your setup is in the cart.'; self.note.hidden = false; self.note.className = 'hdzs-tray__note is-ok'; } },
        onError: function (m) { if (self.note) { self.note.__busy = true; self.note.textContent = m; self.note.hidden = false; self.note.className = 'hdzs-tray__note is-err'; } }
      });
    });
    document.body.classList.add('hdzs-has-tray');
    /* phones: the tray slides in only while the builder is on screen (the hero keeps its own CTA; the FAQ below stays clear) */
    if (this.tray && 'IntersectionObserver' in window) {
      self.tray.classList.add('is-away');
      var io = new IntersectionObserver(function (es) {
        var vis = es[0].isIntersecting;
        if (!vis && self.tray.classList.contains('is-open')) return;
        self.tray.classList.toggle('is-away', !vis);
        document.body.classList.toggle('hdzs-has-tray', vis);
      }, { rootMargin: '-35% 0px -25% 0px' });
      io.observe($('.hdzs-builder__steps', root) || root);
    }
    on(document, 'hdzs:bundle', function () { self.update(true); });
    this.update();
  }
  Builder.prototype.picks = function () { return this.cards.map(function (c) { return c.pick; }); };
  Builder.prototype.update = function (fromEngine) {
    var self = this, cfg = this.cfg;
    if (!fromEngine && this.note && /is-err/.test(this.note.className)) { this.note.__busy = false; }
    if (!fromEngine && this.addBtn && this.addBtn.getAttribute('data-added') === '1') { this.addBtn.removeAttribute('data-added'); this.addBtn.classList.remove('is-done'); this.addBtn.textContent = this.addBtn.getAttribute('data-label') || this.addBtn.textContent; if (this.note) { this.note.__busy = false; } }
    var sum = summarize(this.picks());
    /* step states */
    $$('[data-hdzs-step]', this.root).forEach(function (stepEl) {
      var key = stepEl.getAttribute('data-hdzs-step'), st = $('[data-hdzs-step-state]', stepEl); if (!st) return;
      var picked = self.cards.filter(function (c) { return c.step === key && c.pick.on; });
      var skipped = stepEl.classList.contains('is-skipped');
      if (picked.length === 0) st.textContent = skipped ? (cfg.skipped || 'Skipped') : '';
      else if (picked.length === 1) st.textContent = fill(cfg.pickedOne || 'Picked: {name}', { name: picked[0].p.title });
      else st.textContent = fill(cfg.pickedMany || 'Picked: {n} items', { n: picked.length });
      var done = picked.length > 0;
      stepEl.classList.toggle('is-done', done);
      var nx = $('.hdzs-step__next', stepEl); if (nx) nx.hidden = !(done || skipped);
      var chip = $('.hdzs-stepper [data-hdzs-goto="' + key + '"]', self.root);
      if (chip) { chip.classList.toggle('is-done', done); chip.classList.toggle('is-skipped', !done && skipped); }
    });
    /* tray lines */
    var ul = $('[data-hdzs-lines]', this.root);
    if (ul) {
      ul.innerHTML = '';
      this.cards.forEach(function (c) {
        if (!c.pick.on) return;
        var pk = c.pick, li = h('li', { class: 'hdzs-tray__line' });
        li.appendChild(h('img', { src: pk.p.img || '', alt: '', loading: 'lazy', width: '44', height: '44' }));
        var t = h('span', { class: 'hdzs-tray__lt', text: pk.p.title }); var lab = pk.label(); if (lab) t.appendChild(h('small', { text: lab })); li.appendChild(t);
        var pr = h('span', { class: 'hdzs-tray__lp' });
        if (pk.bogo() > 0) { pr.appendChild(h('s', { text: money(pk.total()) })); pr.appendChild(document.createTextNode(money(pk.total() - pk.bogo()))); pr.appendChild(h('small', { text: cfg.freeTag || '2 reels · 1 free' })); }
        else pr.textContent = money(pk.total());
        li.appendChild(pr);
        ul.appendChild(li);
      });
    }
    var cnt = $('[data-hdzs-count]', this.root), cntL = $('[data-hdzs-count-l]', this.root), tot = $('[data-hdzs-total]', this.root), deal = $('[data-hdzs-deal]', this.root);
    if (cnt) setText(cnt, String(sum.units));
    if (cntL) cntL.textContent = sum.units === 1 ? (cfg.unitOne || 'item') : (cfg.unitMany || 'items');
    if (tot) setText(tot, sum.count ? money(sum.total) : '');
    if (deal) { var d = dealLine(sum, cfg); deal.textContent = d.text; deal.className = 'hdzs-tray__deal ' + d.cls; }
    paintRows(this.root, sum, cfg);
    if (this.addBtn) this.addBtn.disabled = sum.count === 0 || sum.unavailable;
  };

  /* ======================================================================
     QUIZ
     ====================================================================== */
  var QKEYS = ['who', 'species', 'exp', 'hand', 'priority'];
  function Quiz(root) {
    var self = this;
    this.root = root;
    root.__hdzsQuiz = this;   /* handle for QA sweeps (read-only use) */
    try { this.cfg = JSON.parse($('[data-hdzs-quiz-cfg]', root).textContent); } catch (e) { this.cfg = { products: {}, copy: {} }; }
    this.cfg.copy = this.cfg.copy || {};
    this.screens = $$('[data-hdzs-screen]', root);
    this.result = $('[data-hdzs-result]', root);
    this.answers = {};
    this.picks = [];
    this.step = 1;
    this.editing = false;
    try { var saved = JSON.parse(sessionStorage.getItem('hdzs_quiz') || 'null'); if (saved && saved.answers) this.answers = saved.answers; } catch (e) { }
    $$('[data-hdzs-tiles]', root).forEach(function (grid) {
      var q = grid.getAttribute('data-q');
      $$('.hdzs-tile', grid).forEach(function (tile) {
        if (!$('.hdzs-tile__tick', tile)) tile.appendChild(h('span', { class: 'hdzs-tile__tick', 'aria-hidden': 'true', html: icon('check', 16, 3.5) }));
        on(tile, 'click', function () {
          if (self.__lock) return;
          $$('.hdzs-tile', grid).forEach(function (t) { t.classList.toggle('is-on', t === tile); t.setAttribute('aria-checked', t === tile ? 'true' : 'false'); });
          self.answers[q] = tile.getAttribute('data-value');
          self.save();
          self.__lock = true;                                   /* let the tick land before the next question slides in */
          setTimeout(function () {
            self.__lock = false;
            var complete = QKEYS.every(function (k) { return self.answers[k]; });
            if (self.editing && complete) { self.editing = false; self.showResult(true); }
            else self.go(self.step + 1, false, 1);
          }, RM ? 120 : 360);
        });
        on(tile, 'keydown', function (e) {
          var tiles = $$('.hdzs-tile', grid), i = tiles.indexOf(tile), d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!d) return; e.preventDefault(); tiles[(i + d + tiles.length) % tiles.length].focus();
        });
      });
    });
    $$('[data-hdzs-back]', root).forEach(function (b) { on(b, 'click', function () { self.go(self.step - 1, false, -1); }); });
    $$('[data-hdzs-restart]', root).forEach(function (b) { on(b, 'click', function () { self.answers = {}; self.editing = false; self.save(); $$('.hdzs-tile', root).forEach(function (t) { t.classList.remove('is-on'); t.setAttribute('aria-checked', 'false'); }); self.go(1, false, -1); }); });
    on(document, 'hdzs:bundle', function () { if (self.picks.length && !self.result.hidden) self.paint(true); });
    on(window, 'pageshow', function (e) {
      if (!e.persisted || !self.result) return;
      var b = $('[data-hdzs-add-set]', self.result), n = $('[data-hdzs-note]', self.result);
      if (b) { b.__lock = false; b.removeAttribute('data-added'); b.removeAttribute('aria-busy'); b.classList.remove('is-done', 'is-busy'); b.disabled = false; b.textContent = b.getAttribute('data-label') || b.textContent; }
      if (n) n.__busy = false;
      if (self.picks.length && !self.result.hidden) self.paint();
    });
    var complete = QKEYS.every(function (k) { return self.answers[k]; });
    if (complete) { this.restoreTiles(); this.showResult(false); } else { this.go(1, true); }
  }
  Quiz.prototype.save = function () { try { sessionStorage.setItem('hdzs_quiz', JSON.stringify({ answers: this.answers })); } catch (e) { } };
  Quiz.prototype.restoreTiles = function () {
    var self = this;
    $$('[data-hdzs-tiles]', this.root).forEach(function (grid) { var v = self.answers[grid.getAttribute('data-q')]; $$('.hdzs-tile', grid).forEach(function (t) { var onIt = t.getAttribute('data-value') === v; t.classList.toggle('is-on', onIt); t.setAttribute('aria-checked', onIt ? 'true' : 'false'); }); });
  };
  Quiz.prototype.setProgress = function (n, done) {
    var total = this.screens.length, c = this.cfg.copy;
    $$('[data-hdzs-segs] > i', this.root).forEach(function (seg, i) { seg.classList.toggle('is-done', done || i + 1 < n); seg.classList.toggle('is-cur', !done && i + 1 === n); });
    var txt = $('[data-hdzs-qstep]', this.root);
    if (txt) txt.textContent = done ? (c.done || 'Your setup') : fill(c.stepOf || 'Question {n} of {total}', { n: n, total: total });
    $$('[data-hdzs-back]', this.root).forEach(function (b) { b.hidden = done || n === 1; });
  };
  function animIn(el, cls) {
    if (RM || !el) return;
    el.classList.remove('is-in-fwd', 'is-in-back', 'is-in-up');
    void el.offsetWidth; el.classList.add(cls);
    var clear = function () { el.classList.remove(cls); el.removeEventListener('animationend', clear); };
    el.addEventListener('animationend', clear);
  }
  /* dir: 1 forward (slide from the right) · -1 back (from the left) */
  Quiz.prototype.go = function (n, silent, dir) {
    var total = this.screens.length;
    if (n > total) { this.showResult(true); return; }
    n = Math.max(1, n);
    this.step = n;
    this.root.classList.remove('is-result');
    if (this.result) this.result.hidden = true;
    var rb = $('[data-hdzs-rbar]', this.root); if (rb) { rb.hidden = true; document.body.classList.remove('hdzs-has-tray'); }
    this.screens.forEach(function (s, i) { s.hidden = (i + 1) !== n; });
    this.setProgress(n, false);
    var scr = this.screens[n - 1];
    if (!silent) {
      animIn(scr, dir === -1 ? 'is-in-back' : 'is-in-fwd');
      var prog = $('.hdzs-quiz__progress', this.root);
      if (prog) { var top = prog.getBoundingClientRect().top; if (top < headerH() || (n > 1 && top > window.innerHeight * 0.3)) scrollToEl(prog, 8); }
      var qh = $('.hdzs-quiz__q', scr); if (qh) setTimeout(function () { try { qh.focus({ preventScroll: true }); } catch (e) { } }, RM ? 0 : 60);
    }
  };
  /* answer chips on the result: tap one → that question (the other answers stay), then straight back to the result */
  Quiz.prototype.renderChips = function () {
    var self = this, box = $('[data-hdzs-chips]', this.result); if (!box) return;
    box.innerHTML = '';
    QKEYS.forEach(function (k, i) {
      var tile = $('[data-hdzs-tiles][data-q="' + k + '"] .hdzs-tile[data-value="' + self.answers[k] + '"]', self.root);
      var t = tile ? ($('.hdzs-tile__t', tile) || tile).textContent.trim() : '';
      if (!t) return;
      var b = h('button', { type: 'button', class: 'hdzs-chip', 'aria-label': (self.cfg.copy.chipEdit || 'Change') + ': ' + t });
      b.appendChild(h('span', { text: t }));
      b.insertAdjacentHTML('beforeend', '<svg class="hdzb-i" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>');
      on(b, 'click', function () { self.editing = true; self.go(i + 1, false, -1); });
      box.appendChild(b);
    });
  };
  /* --- kit rules --- */
  Quiz.prototype.buildKit = function () {
    var a = this.answers, P = this.cfg.products, cfg = this.cfg, picks = [];
    var heavy = ['catfish', 'pike', 'redfish'].indexOf(a.species) > -1;
    /* 05.10 (comment to Q5): "The best reel we make" → the Cast Master Pro. Its free reel is a Kaching deal that applies only
       through the widget on its product page, so this reel is not added here: the button adds the rest and opens that page. */
    var premium = !!(P.premium && a.priority === 'smooth');
    var upgrade = !premium && !!(P.upgrade && a.exp === 'years' && a.priority !== 'money' && a.hand !== 'unsure');   /* 'not sure' → the pair, so one right + one left is what gets added */
    var reelP = premium ? P.premium : upgrade ? P.upgrade : P.pair;
    if (!reelP && P.pair) reelP = P.pair;
    if (reelP) {
      var reel = new Pick(reelP, { role: 'reel' });
      var hand = a.hand === 'left' ? 'left' : 'right';
      reel.setHand(hand, 0);
      if (reelP.pair) reel.setHand(a.hand === 'unsure' ? 'left' : hand, 1);
      reel.why = premium ? (cfg.copy.whyPremium || '') : upgrade ? (cfg.copy.whyUpgrade || '') : (a.who === 'kid' ? (cfg.copy.whyPairKid || '') : (cfg.copy.whyPair || ''));
      reel.swappable = !premium && !!(P.upgrade && P.pair);
      reel.isUpgrade = upgrade;
      reel.linkOut = premium;
      picks.push(reel);
    }
    var reelsOnly = a.priority === 'money';   /* 06.10: «Just the reels — no rod, no line» → the pair only; more goes through «Customize it» */
    if (P.rod && !reelsOnly) { var rod = new Pick(P.rod, { role: 'rod', optional: true }); rod.why = cfg.copy.whyRod || ''; picks.push(rod); }
    if (P.line && !reelsOnly) {
      var line = new Pick(P.line, { role: 'line', optional: true });
      var li = optIndex(P.line, 'capacity') > -1 ? optIndex(P.line, 'capacity') : optIndex(P.line, 'line');
      var ci = optIndex(P.line, 'color');
      if (ci > -1 && cfg.lineColor) { var cols = line.values(ci); var pc = cols.filter(function (c) { return c.toLowerCase() === String(cfg.lineColor).toLowerCase(); })[0]; if (pc) line.set(ci, pc, 0); }
      if (li > -1) { var want = heavy ? cfg.lb.heavy : cfg.lb.light; var vals = line.values(li); var match = vals.filter(function (v) { return v.toUpperCase().indexOf(String(want).toUpperCase()) > -1; })[0]; if (match) line.set(li, match, 0); }
      line.why = heavy ? (cfg.copy.whyLineHeavy || '') : (cfg.copy.whyLineLight || '');
      picks.push(line);
    }
    var lureKey = { bass: 'lureBass', pike: 'lureBig', redfish: 'lureSalt', crappie: 'lureSmall', trout: 'lureSmall' }[a.species];
    if (lureKey && P[lureKey] && !reelsOnly) {
      var lure = new Pick(P[lureKey], { role: 'lure', optional: true });
      var pref = cfg.prefer && cfg.prefer[a.species];
      if (pref) { var pv = pool(P[lureKey]).filter(function (v) { return v.available && String(v.title).toLowerCase().indexOf(String(pref).toLowerCase()) > -1; })[0]; if (pv) pv.opts.forEach(function (x, j) { lure.chosen[j] = x; }); }
      lure.why = (cfg.copy['whyLure_' + a.species]) || cfg.copy.whyLure || '';
      picks.push(lure);
    }
    if (P.tool && !reelsOnly && (heavy || a.priority === 'ready')) { var tool = new Pick(P.tool, { role: 'tool', optional: true }); tool.why = cfg.copy.whyTool || ''; picks.push(tool); }
    return picks;
  };
  Quiz.prototype.swapReel = function () {
    var reel = this.picks.filter(function (p) { return p.role === 'reel'; })[0]; if (!reel) return;
    var P = this.cfg.products, a = this.answers, toUpgrade = !reel.isUpgrade;
    var np = new Pick(toUpgrade ? P.upgrade : P.pair, { role: 'reel' });
    var hand = reel.hand(0) || (a.hand === 'left' ? 'left' : 'right');
    np.setHand(hand, 0); if (np.p.pair) np.setHand(a.hand === 'unsure' ? (hand === 'right' ? 'left' : 'right') : hand, 1);
    np.why = toUpgrade ? (this.cfg.copy.whyUpgrade || '') : (a.who === 'kid' ? (this.cfg.copy.whyPairKid || '') : (this.cfg.copy.whyPair || ''));
    np.swappable = true; np.isUpgrade = toUpgrade;
    this.picks[this.picks.indexOf(reel)] = np;
    this.renderKit(); this.paint();
  };
  Quiz.prototype.showResult = function (scroll) {
    this.picks = this.buildKit();
    this.screens.forEach(function (s) { s.hidden = true; });
    if (this.result) this.result.hidden = false;
    this.root.classList.add('is-result');
    this.setProgress(this.screens.length, true);
    this.renderWhy();
    this.renderChips();
    this.renderKit();
    this.paint();
    var alt = $('[data-hdzs-alt]', this.result);
    if (alt) { alt.hidden = !alt.textContent.trim(); var ah = $('[data-hdzs-althint]', alt); if (ah) ah.hidden = this.answers.hand !== 'unsure'; }
    if (scroll) {
      if (!RM) { this.result.classList.remove('is-reveal'); void this.result.offsetWidth; this.result.classList.add('is-reveal'); }
      scrollToEl($('.hdzs-quiz__progress', this.root), 8);
      var hh = $('[data-hdzs-rh]', this.result); if (hh) setTimeout(function () { try { hh.focus({ preventScroll: true }); } catch (e) { } }, 60);
    }
  };
  Quiz.prototype.renderWhy = function () {
    var a = this.answers, c = this.cfg.copy, root = this.result;
    var hh = $('[data-hdzs-rh]', root), lead = $('[data-hdzs-rlead]', root), why = $('[data-hdzs-why]', root), gift = $('[data-hdzs-gift]', root);
    var head = a.who === 'gift' ? c.headGift : a.who === 'kid' ? c.headKid : c.headMe;
    if (hh) hh.innerHTML = head || 'Your <em>setup.</em>';
    if (lead) lead.textContent = fill(c['lead_' + a.species] || c.lead || '', { species: c['name_' + a.species] || a.species });
    if (why) {
      why.innerHTML = '';
      var bullets = [];
      var exp = c['exp_' + a.exp]; if (exp) bullets.push(exp);
      var sp = c['species_' + a.species]; if (sp) bullets.push(sp);
      var pr = (this.picks || []).some(function (p) { return p.linkOut; }) ? (c.priority_premium || c['priority_' + a.priority]) : c['priority_' + a.priority]; if (pr) bullets.push(pr);
      bullets.forEach(function (t) { var li = h('li', { html: icon('check', 22, 3) + '<span></span>' }); li.lastChild.textContent = t; why.appendChild(li); });
      var hl = h('li', { 'data-hdzs-handbullet': '1', html: icon('check', 22, 3) + '<span></span>' }); why.appendChild(hl);
      this.paintHand();
    }
    if (gift) gift.hidden = a.who !== 'gift';
  };
  var ROLE_ICON = { reel: 'reel', rod: 'rod', line: 'spool', lure: 'lure', tool: 'pliers' };
  /* the hand line always describes what will be added (after swaps / hand changes), never just the answer */
  Quiz.prototype.paintHand = function () {
    var li = $('[data-hdzs-handbullet]', this.result); if (!li) return;
    var a = this.answers, c = this.cfg.copy, reel = this.picks.filter(function (p) { return p.role === 'reel' && p.on; })[0];
    var txt = '';
    if (reel && reel.handIdx > -1) {
      var h0 = reel.hand(0), h1 = reel.p.pair ? reel.hand(1) : h0;
      txt = h0 !== h1 ? (a.who === 'gift' ? c.hand_unsure_gift : c.hand_unsure) : (h0 === 'left' ? c.hand_left : c.hand_right);
    }
    li.hidden = !txt;
    if (li.lastChild.textContent !== (txt || '')) li.lastChild.textContent = txt || '';
  };
  Quiz.prototype.renderKit = function (focusRole) {
    var self = this, kit = $('[data-hdzs-kit]', this.result), c = this.cfg.copy, roles = c.roles || {}; if (!kit) return;
    kit.innerHTML = '';
    this.picks.forEach(function (pk, idx) {
      /* Rustam 02.10: no "Remove" on the result — the kit goes to the cart as shown; items are removed only in "Customize it"
         (the bundle builder, pre-filled with this kit). Every pick stays on. */
      if (pk.optional) pk.on = true;
      var p = pk.p, line = h('div', { class: 'hdzs-kline' + (pk.optional ? ' hdzs-kline--opt' : '') + (pk.on ? '' : ' is-off'), 'data-role': pk.role, style: '--i:' + idx });
      line.appendChild(h('img', { class: 'hdzs-kline__img', src: p.img || '', alt: '', loading: 'lazy', width: '64', height: '64' }));
      var b = h('div', { class: 'hdzs-kline__b' });
      var roleTxt = p.pair ? (roles.reels || 'Reels · 2 for 1') : (roles[pk.role] || pk.role);
      b.appendChild(h('div', { class: 'hdzs-kline__role', html: icon(ROLE_ICON[pk.role] || 'check', 16, 2.25) + '<span>' + esc(roleTxt) + '</span>' }));
      b.appendChild(h('div', { class: 'hdzs-kline__t', text: p.title }));
      if (p.pair) b.appendChild(h('span', { class: 'hdzb-badge hdzs-kline__badge', text: c.badgePair || 'Buy 1 get 1 free' }));
      if (pk.linkOut) b.appendChild(h('span', { class: 'hdzb-badge hdzs-kline__badge', text: c.badgePremium || 'Comes with a free reel' }));
      if (pk.why) b.appendChild(h('div', { class: 'hdzs-kline__s', text: pk.why }));
      if (pk.role !== 'reel' && pk.role !== 'line') { var vl = pk.label(); if (vl && !/^#\d+$/.test(vl)) b.appendChild(h('div', { class: 'hdzs-kline__v', text: vl })); }   /* the exact variant that will be added (lure colour / weight, pliers set) */
      line.appendChild(b);
      var pr = h('div', { class: 'hdzs-kline__p' });
      line.appendChild(pr);
      var opts = h('div', { class: 'hdzs-kline__opts' });   /* full-width row under the line: the hand switch is the most tapped control */
      line.appendChild(opts);
      var foot = h('div', { class: 'hdzs-kline__foot' });
      if (pk.role === 'reel' && pk.swappable) { var sw = h('button', { type: 'button', class: 'hdzs-kline__swap', html: icon('repeat', 16, 2.5) + '<span>' + esc(pk.isUpgrade ? (c.swapToPair || 'Swap to the two-reel deal') : (c.swapToUpgrade || 'Swap to the King Cast')) + '</span>' }); on(sw, 'click', function () { self.swapReel(); }); foot.appendChild(sw); }
      if (foot.children.length) line.appendChild(foot);
      pk.__price = pr; pk.__line = line;
      /* pickers: hand (reels), line strength (line); colour stays the preset (keep it simple) */
      if ((pk.role === 'reel' || pk.role === 'line') && pk.on) {
        renderPickers(opts, pk, { reelLabels: [c.reel1 || 'Reel 1 · handle on the', c.reel2 || 'Reel 2 · handle on the'], mixHint: p.pair ? (self.answers.who === 'gift' ? (c.mixHintGift || '') : (c.mixHint || '')) : '', handLabel: c.handLabel || 'Handle on the' });
        if (pk.role === 'line') { $$('select[data-hdzs-opt]', opts).forEach(function (s) { var w = s.closest('.hdzs-opt'); if (w) w.hidden = true; }); }
        bindPickers(opts, pk, function () { self.paint(); bump(pk.__price); });
      }
      if (!opts.children.length) opts.remove();
      kit.appendChild(line);
    });
    if (focusRole) { var fb = $('[data-role-btn="' + focusRole + '"]', kit); if (fb) try { fb.focus({ preventScroll: true }); } catch (e) { } }
  };
  Quiz.prototype.paint = function (fromEngine) {
    var self = this, c = this.cfg.copy;
    this.picks.forEach(function (pk) {
      if (!pk.__price) return;
      pk.__price.innerHTML = '';
      if (pk.bogo() > 0) { pk.__price.appendChild(h('s', { text: money(pk.total()) })); pk.__price.appendChild(h('span', { text: money(pk.total() - pk.bogo()) })); pk.__price.appendChild(h('small', { text: c.freeTag || '2 reels · 1 free' })); }
      else { pk.__price.appendChild(document.createTextNode(money(pk.total()))); if (pk.compare() > pk.price()) pk.__price.appendChild(h('s', { text: money(pk.compare() * pk.units()) })); }
      pk.__line.classList.toggle('is-off', !pk.on);
    });
    this.paintHand();
    var sum = summarize(this.picks);
    paintRows(this.result, sum, this.cfg.copy);
    var btn = $('[data-hdzs-add-set]', this.result);
    /* "Customize it" → the bundle builder pre-filled with this kit: ?bundle=<variantId>[x<qty>],… (wave 4) */
    var cust = $('[data-hdzs-customize]', this.result);
    if (cust) {
      var ids = [];
      this.picks.forEach(function (pk) { if (pk.on && !pk.linkOut) pk.cartItems().forEach(function (it) { ids.push(it.id + (it.quantity > 1 ? 'x' + it.quantity : '')); }); });
      var base = cust.getAttribute('data-base') || '/pages/hdzb-setup';
      cust.setAttribute('href', ids.length ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'bundle=' + ids.join(',') + '#build' : base);
    }
    var bar = $('[data-hdzs-rbar]', this.root);
    if (bar) {
      var bt = $('[data-hdzs-rbar-total]', bar); if (bt) setText(bt, sum.count ? money(sum.total) : '');
      var bb = $('[data-hdzs-rbar-btn]', bar); if (bb) { bb.disabled = !btn || btn.disabled; if (!bb.__bound) { bb.__bound = true; on(bb, 'click', function () { if (btn && !btn.disabled) { btn.click(); btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }); } }
      if (!bar.__io && 'IntersectionObserver' in window && btn) {
        var box = btn.closest('.hdzs-sum') || btn;
        bar.__io = new IntersectionObserver(function (es) { var vis = es[0].isIntersecting; var show = !vis && !self.result.hidden && window.innerWidth < 990; bar.hidden = !show; document.body.classList.toggle('hdzs-has-tray', show); }, { threshold: 0.15 });
        bar.__io.observe(box);
      }
      if (this.result.hidden) { bar.hidden = true; document.body.classList.remove('hdzs-has-tray'); }
    }
    if (!btn) return;
    var link = this.picks.filter(function (p) { return p.on && p.linkOut; })[0];
    if (!btn.hasAttribute('data-label-base')) btn.setAttribute('data-label-base', btn.getAttribute('data-label') || btn.textContent);
    var wantLabel = link ? (c.premiumCta || 'Continue to the reel') : btn.getAttribute('data-label-base');
    if (btn.getAttribute('data-label') !== wantLabel) { btn.setAttribute('data-label', wantLabel); if (!btn.__lock && btn.getAttribute('data-added') !== '1') btn.textContent = wantLabel; }
    var pnote = $('[data-hdzs-note]', this.result);
    if (link && pnote && !pnote.__busy && c.premiumNote) { pnote.textContent = c.premiumNote; pnote.hidden = false; pnote.className = pnote.className.replace(/\bis-(ok|err)\b/g, '').trim(); }
    btn.disabled = sum.count === 0 || sum.unavailable;
    if (btn.getAttribute('data-added') === '1' && !btn.__lock && !fromEngine) { btn.removeAttribute('data-added'); btn.classList.remove('is-done'); btn.textContent = btn.getAttribute('data-label') || btn.textContent; }
    if (!btn.__bound) {
      btn.__bound = true;
      on(btn, 'click', function () {
        if (btn.getAttribute('data-added') === '1') { H().cart.open(); return; }
        var a = self.answers, attrs = { _hdzs_source: 'quiz', _quiz_who: a.who || '', _quiz_species: a.species || '', _quiz_experience: a.exp || '', _quiz_hand: a.hand || '', _quiz_priority: a.priority || '', _quiz_kit: self.picks.filter(function (p) { return p.on; }).map(function (p) { return p.p.handle; }).join(',') };
        var note = $('[data-hdzs-note]', self.result); if (note) note.__busy = true;
        var lk = self.picks.filter(function (p) { return p.on && p.linkOut; })[0];
        if (lk) {
          var lv = lk.variant(0), url = (lk.p.url || ('/products/' + lk.p.handle)) + (lv ? '?variant=' + lv.id : '');
          var rest = self.picks.filter(function (p) { return p.on && !p.linkOut; });
          attrs._quiz_kit = rest.map(function (p) { return p.p.handle; }).join(','); attrs._quiz_next = lk.p.handle;
          if (!rest.length) { window.location.href = url; return; }
          btn.__lock = true;
          addSetFlow(btn, rest, { attributes: attrs, open: false,
            onDone: function () { btn.__lock = false; if (note) note.__busy = false; window.location.href = url; },
            onError: function (m) { btn.__lock = false; if (note) { note.__busy = true; note.textContent = m; note.hidden = false; note.className = 'hdzs-tray__note is-err'; setTimeout(function () { note.__busy = false; }, 8000); } } });
          return;
        }
        btn.__lock = true;
        addSetFlow(btn, self.picks, {
          attributes: attrs,
          onDone: function () { btn.__lock = false; if (note) { note.textContent = c.added || 'Your setup is in the cart.'; note.hidden = false; note.className = 'hdzs-tray__note is-ok'; } },
          onError: function (m) { btn.__lock = false; if (note) { note.__busy = true; note.textContent = m; note.hidden = false; note.className = 'hdzs-tray__note is-err'; setTimeout(function () { note.__busy = false; }, 8000); } }
        });
      });
    }
  };

  /* ---------- tier amounts in the hero (USD settings → active currency) ---------- */
  function paintTiers() {
    var eng = E(); if (!eng || !eng.tiers) return;
    $$('[data-hdzs-tier-amount]').forEach(function (el) { var t = eng.tiers[Number(el.getAttribute('data-hdzs-tier-amount')) - 1]; if (t && !el.textContent.trim()) el.textContent = moneyT(eng.usd(t.amount)); });
    $$('[data-hdzs-tier-min]').forEach(function (el) { var t = eng.tiers[Number(el.getAttribute('data-hdzs-tier-min')) - 1]; if (t && !el.textContent.trim()) el.textContent = moneyT(eng.usd(t.min)); });
  }

  function boot() {
    if (!H() || !E()) { setTimeout(boot, 40); return; }
    paintTiers();
    $$('[data-hdzs-builder]').forEach(function (r) { if (!r.__hdzs) { r.__hdzs = true; try { new Builder(r); } catch (e) { console.error('[hdzs] builder', e); } } });
    $$('[data-hdzs-quiz]').forEach(function (r) { if (!r.__hdzs) { r.__hdzs = true; try { new Quiz(r); } catch (e) { console.error('[hdzs] quiz', e); } } });
    document.addEventListener('shopify:section:load', function () { setTimeout(boot, 50); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
